export default __webpack_public_path__ + "static/media/video3.cd5473b8.mp4";